/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-18T18:02:48.279
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getAuthFuncRoleManageEditInit,
	getAuthFuncRoleManageView
} from '@api/systemmanage/AuthFuncRoleManage';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getAuthFuncRoleManageEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getAuthFuncRoleManageEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getAuthFuncRoleManageView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getAuthFuncRoleManageView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
